import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@wandero/shared';
import { dexieStorageAdapter } from './storage-adapter';
import { env } from '../lib/env';

let _client: SupabaseClient<Database> | null = null;

export function getSupabase(): SupabaseClient<Database> {
  if (_client) return _client;
  _client = createClient<Database>(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY, {
    auth: {
      // Supabase expects sync Storage interface, but async works in practice.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      storage: dexieStorageAdapter as any,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return _client;
}

/** Reset singleton — for testing only */
export function _resetSupabaseClient(): void {
  _client = null;
}
